<template>
  <global-wrapper :loading="loading" :loadingType="'avatar-three-line'" :loadingList="1" :scrollable="true" class="mb-3">
    <div class="vx-row" v-if="!loading">
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="LogInIcon"
          :statistic="recapData.all | commas"
          statisticTitle="Permohonan Masuk"
        />
      </div>
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="CheckIcon"
          :statistic="recapData.done | commas"
          statisticTitle="Selesai / Terbit"
        />
      </div>
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="ClockIcon"
          :statistic="recapData.on_process | commas"
          statisticTitle="Dalam Proses"
        />
      </div>
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="EditIcon"
          :statistic="recapData.on_revision | commas"
          statisticTitle="Revisi Berkas"
        />
      </div>
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="XSquareIcon"
          :statistic="recapData.revoked | commas"
          statisticTitle="Izin Dicabut"
        />
      </div>
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="XCircleIcon"
          :statistic="recapData.rejected+recapData.canceled | commas"
          statisticTitle="Ditolak & Dibatalkan"
        />
      </div>
    </div>
  </global-wrapper>
</template>

<script>
  import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

  export default {
    components: {
      StatisticsCardLine
    },
    data(){
      return {
        loading: true,
        recapData: {}
      }
    },
    created(){
      this.fetchData()
    },
    methods: {
      async fetchData(){
        this.loading = true;
        const res = await this.$http.get('/dashboard/permohonan-recap-data');
        this.recapData = res.data.data;
        this.loading = false;
      }
    },
    filters: {
      commas(num){
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      }
    }
  }
</script>